// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 676 ? "9932c28f" : chunkId) + "." + {"269":"167f9de0c0291665","676":"bddc310cd5431cad","975":"0fbf9c5d8aac816e"}[chunkId] + ".js";
};